import { defineStore } from "pinia";
import {
  index,
  get,
  post,
  put,
  getUnregistered,
  getUserActiveStatus,
  putDeactivateOrgstatus,
  putActivateOrgstatus,
  getGstDetails,
  getLastUserStatus,
  getPanDetails,
} from "src/api/organisations";
import { usePagination } from "src/composables/pagination";
import OrganisationForm from "src/modules/organisations/components/OrganisationForm.vue";
const getInitialState = () => {
  return {
    counts: {},
    organisations: [],
    organisation: {},
    organisationsStatuses: [],
  };
};

export const useOrganisationStore = defineStore("organisation", () => {
  const { state: formState, toggle: toggleOrganisationDrawer } = useDrawer({
    component: OrganisationForm,
  });

  let state = reactive(getInitialState());

  const filters = ref({
    is_active: null,
  });

  const { filter, pagination, params } = usePagination(filters);

  const setOrganisation = (updatedorganisation) => {
    if (!updatedorganisation) {
      state.organisation = {};

      return;
    }

    state.organisation = {
      ...updatedorganisation,
      gstin: "",
      gstin_business: updatedorganisation.gstin || "",
    };
  };

  const getOrganisations = async (options = {}) => {
    try {
      const response = await index({
        params: params.value,
        ...unref(options),
      });

      state.organisations = response?.data?.data?.data;

      pagination.value.rowsNumber = response?.data?.data?.count;

      return response;
    } catch (error) {
      console.error(error);

      throw error;
    }
  };

  const postOrganisation = async (organisation, options = {}) => {
    const response = await post(organisation, options);

    setOrganisation(response.data?.data);

    return response;
  };

  const putOrganisation = async (organisation) => {
    const response = await put(organisation);

    setOrganisation(response.data?.data);

    return response;
  };

  const getOrganisationById = async (orgId) => {
    try {
      const response = await get(orgId);

      setOrganisation(response.data?.data);

      return response;
    } catch (error) {
      console.error(error);

      throw error;
    }
  };

  const getUnregisteredOrg = async (name) => {
    const response = await getUnregistered({ params: { name } });

    return response?.data?.data;
  };

  const getUserStatus = async (id) => {
    try {
      const response = await getUserActiveStatus(id);
      const status = response?.data?.canDeactivate;

      return status;
    } catch (error) {
      console.error(error);

      throw error;
    }
  };

  const deactivateOrg = async (id) => {
    const response = await putDeactivateOrgstatus(id);

    return response;
  };

  const activateOrg = async (id) => {
    const response = await putActivateOrgstatus(id);

    return response;
  };

  const getGstDetailsData = async ({ gstin }) => {
    const response = await getGstDetails({ gstin });

    setOrganisation(response.data?.data);

    return response.data?.data;
  };

  const getlastUserActiveStatus = async (orgId, userId) => {
    const response = await getLastUserStatus({
      params: { org_id: orgId, user_id: userId },
    });

    return response.data?.data;
  };

  const getPanDetail = async (pan, options = {}) => {
    const response = await getPanDetails(pan, options);

    if (!options?.params?.org) {
      setOrganisation(response.data?.data);
    }

    return response.data?.data;
  };

  const reset = () => {
    Object.assign(state, getInitialState());
  };

  return {
    toggleOrganisationDrawer,
    formState,
    ...toRefs(state),
    filter,
    filters,
    pagination,
    setOrganisation,
    getOrganisations,
    postOrganisation,
    putOrganisation,
    getOrganisationById,
    getUnregisteredOrg,
    getUserStatus,
    deactivateOrg,
    activateOrg,
    getGstDetailsData,
    getlastUserActiveStatus,
    getPanDetail,
    params,
    reset,
  };
});
